import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  email: String = '';
  password: String = '';

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    if (localStorage.getItem('authorization')) {
      this.router.navigate(['/dashboard/library']);
    }
  }

  login() {
    // TODO make a login request
    localStorage.setItem('authorization', btoa(`${this.email}:${this.password}`));
    this.router.navigate(['/dashboard/library']);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/login/login.component.ts